module.exports = "/next-static/_next/static/images/recording-0149d1d836e9ede281b11d9353ec9183.png";